module.exports = __webpack_public_path__ + "static/media/news-weather-holiday-blues.e26426fb.jpg";